<template>
  <div class="functional functional__user"
       v-if="user.data"
  >
    <el-dropdown @command="handleCommand" trigger="click">
      <span class="functional-link functional-link__user">
        <font-awesome-icon icon="user-circle"/>
      </span>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item disabled class="user__account" ref="user__account">
          {{ user.data.account }}
        </el-dropdown-item>

        <template>
          <el-dropdown-item divided command="changePassword">
            更改密碼
          </el-dropdown-item>

          <el-dropdown-item v-if="user.data.fb_id" command="unbindFacebook">
            取消綁定Facebook
          </el-dropdown-item>

          <!--
	  <el-dropdown-item v-else command="bindFacebook">
            綁定Facebook
          </el-dropdown-item>
	  -->

          <el-dropdown-item command="logout">
            登出
          </el-dropdown-item>
        </template>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import axios from "axios";
import qs from "qs";

export default {
  name: 'user',
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout',
      notify: 'notification/notify'
    }),
    goToMemberCenter() {
      let url = 'https://member.studioclassroom.com/login.php'

      window.open(url, '_blank')
    },
    changePassword() {
      this.$confirm('1. 請至空英會員中心，使用您的帳號及目前密碼登入<br>2. 點選右上方「更改密碼」選項，輸入新密碼後送出即可', '更改密碼', {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        confirmButtonText: '前往空英會員中心',
        cancelButtonText: '關閉',
        cancelButtonClass: 'el-button--info',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.goToMemberCenter()
          } else {
            done()
          }
        }
      }).then(() => {
      }).catch(() => {
      })
    },
    getProfile(email) {
      FB.api('/me?fields=name,id,email', function (response) {
        let data = qs.stringify({
          email: email,
          fb_id: response.id
        })
        axios.post('bindFacebook.php', data).then(function (response) {
          if (response.data.result) {
            alert('綁定成功')
          } else {
            alert('綁定失敗')
          }
        })
      })
    },
    unbindFacebook(email) {
      let data = qs.stringify({
        email: email,
      })
      axios.post('unbindFacebook.php', data).then(function (response) {
        if (response.data.result) {
          alert('取消綁定成功')
        } else {
          alert('取消綁定失敗')
        }
      })
    },

    bindFacebook(email) {
      let vm = this
      FB.login(function (response) {
        console.log('res when login', response)
        vm.getProfile(email);
      }, {
        scope: 'email, public_profile',
        return_scopes: true
      });
    },
    async handleCommand(command) {
      if (command === 'changePassword') {
        this.changePassword()
        return
      }

      if (command === 'logout') {
        await this.logout()

        this.$router.replace({name: 'login'})
        this.notify({context: this, message: '使用者登出'})
        return
      }

      if (command === 'bindFacebook') {
        let email = this.$store.getters["auth/user"].data.account;
        this.bindFacebook(email);
      }

      if (command === 'unbindFacebook') {
        let email = this.$store.getters["auth/user"].data.account;
        this.unbindFacebook(email);
      }
    }
  }
}
</script>
